<span>Source: </span>
<a [href]="data.source">{{data.credit}}</a>